import {
    CButton,
    CFormCheck,
    CModal,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle
} from '@coreui/react-pro';
import React, { useEffect, useState } from 'react';
import { isNotNull, logOutUser } from 'src/utils/constants';
import './tncModal.css';

import {
    HiOutlineArrowPath,
    HiOutlineArrowRightOnRectangle,
    HiOutlineEnvelope,
    HiOutlineBuildingOffice2,
    HiOutlineInformationCircle,
    HiOutlineDocumentText
} from 'react-icons/hi2';
import { MdOutlineDescription, MdOutlineWarningAmber } from 'react-icons/md';
import { FaFileContract } from 'react-icons/fa6';
import fetchRequest from 'src/network';

const TncModal = ({
    user,
    acceptTnC,
    setAcceptTnC,
    handleVerify
}) => {
    const [isReloading, setIsReloading] = useState(false);

    const [tncDocUrl, setTncDocUrl] = useState(null);

    const handlelogOut = () => {
        logOutUser();
        window.location.reload();
        return;
    };

    const handleReload = () => {
        setIsReloading(true);
        setTimeout(() => {
            window.location.reload();
        }, 350);
    };

    const documentUrl = typeof user?.tnc_document === 'string'
        ? user?.tnc_document
        : user?.tnc_document?.public_url || null;

    const hasDocument = isNotNull(documentUrl);

    useEffect(() => {
        if (isNotNull(documentUrl)) {
            fetchRequest?.get(documentUrl)?.then((response) => {
                if (response?.status_code === 200) {
                    setTncDocUrl(response?.data?.url);
                } else {
                    setTncDocUrl(null);
                }
            })?.catch(() => {
                setTncDocUrl(null);
            });
        } else {
            setTncDocUrl(null);
        }
    }, [documentUrl]);

    const vendorDisplayName = user?.organization_name || user?.org_name || user?.name || 'Vendor Partner';
    const vendorEmail = user?.email || 'N/A';

    return (
        <div>
            <CModal
                fullscreen
                backdrop="static"
                alignment="center"
                size={'lg'}
                visible={true}
                onClose={() => handlelogOut()}
                aria-labelledby="TncModalLabel"
            >
                <CModalHeader closeButton={true} className="border-bottom px-4 py-3 bg-white">
                    <CModalTitle id="TncModalLabel" className="d-flex align-items-center gap-2 h5 mb-0 fw-semibold text-dark">
                        <FaFileContract className="text-primary" />
                        <span>Terms & Conditions</span>
                    </CModalTitle>
                </CModalHeader>

                <CModalBody className="p-0">
                    {hasDocument ? (
                        <div className="p-3 tnc-viewer-container">
                            <div className="tnc-viewer-topbar">
                                <small className="text-muted d-flex align-items-center gap-2">
                                    <HiOutlineDocumentText className="text-primary fs-5" />
                                    <span>Please scroll through and read the full agreement before accepting.</span>
                                </small>
                                <a
                                    href={tncDocUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1"
                                    style={{ fontSize: '0.78rem', padding: '3px 10px' }}
                                >
                                    <span>Open Document in New Tab</span>
                                    <span aria-hidden="true">↗</span>
                                </a>
                            </div>
                            <div className="tnc-viewer-iframe-wrapper">
                                <iframe
                                    src={`${tncDocUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                                    title="Terms and Conditions PDF Viewer"
                                    className="tnc-viewer-iframe"
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="tnc-empty-wrapper">
                            <div className="tnc-empty-card">
                                <div className="tnc-card-top-accent"></div>

                                {/* Top Status & Icon */}
                                <div className="text-center mb-4">
                                    <div className="tnc-icon-badge-container">
                                        <div className="tnc-icon-badge-ring"></div>
                                        <div className="tnc-icon-badge">
                                            <MdOutlineDescription />
                                            <div className="tnc-status-sub-badge">
                                                <MdOutlineWarningAmber />
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className="tnc-pill-tag">
                                            <span className="tnc-pulse-dot"></span>
                                            <span>Document Unavailable</span>
                                        </div>
                                    </div>

                                    <h3 className="tnc-empty-title">
                                        No Terms & Conditions Document Available
                                    </h3>
                                    <p className="tnc-empty-description">
                                        We could not locate an active agreement document for your vendor account. Access to the portal requires reviewing and digitally accepting your company's Terms & Conditions.
                                    </p>
                                </div>

                                {/* Info Grid */}
                                <div className="row g-3 mb-4">
                                    <div className="col-12 col-md-6">
                                        <div className="tnc-info-box">
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <span className="tnc-box-icon tnc-box-icon-blue">
                                                    <HiOutlineBuildingOffice2 />
                                                </span>
                                                <span className="tnc-box-heading">Account Information</span>
                                            </div>
                                            <div className="tnc-info-list">
                                                <div className="tnc-info-row">
                                                    <span className="tnc-info-label">Vendor Name:</span>
                                                    <span className="tnc-info-val fw-semibold">{vendorDisplayName}</span>
                                                </div>
                                                <div className="tnc-info-row">
                                                    <span className="tnc-info-label">Email ID:</span>
                                                    <span className="tnc-info-val">{vendorEmail}</span>
                                                </div>
                                                <div className="tnc-info-row">
                                                    <span className="tnc-info-label">Portal Status:</span>
                                                    <span
                                                        className="badge px-2 py-1"
                                                        style={{
                                                            backgroundColor: '#fffbeb',
                                                            color: '#b45309',
                                                            border: '1px solid #fde68a',
                                                            fontSize: '0.75rem'
                                                        }}
                                                    >
                                                        Pending T&C
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="tnc-info-box">
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <span className="tnc-box-icon tnc-box-icon-amber">
                                                    <HiOutlineInformationCircle />
                                                </span>
                                                <span className="tnc-box-heading">Why am I seeing this?</span>
                                            </div>
                                            <p className="tnc-info-text mb-0">
                                                The Kuruma (KTPL) operations administrator has not uploaded or linked the Terms & Conditions agreement to your vendor profile yet.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* What to do next (Steps) */}
                                <div className="tnc-steps-card mb-4">
                                    <h6 className="fw-bold text-dark mb-2 d-flex align-items-center gap-2" style={{ fontSize: '0.9rem' }}>
                                        <span
                                            className="badge rounded-circle bg-primary text-white p-0"
                                            style={{ width: '18px', height: '18px', fontSize: '11px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            i
                                        </span>
                                        What should you do next?
                                    </h6>
                                    <div className="tnc-steps-list">
                                        <div className="tnc-step-item">
                                            <div className="tnc-step-num">1</div>
                                            <div className="tnc-step-content">
                                                <strong>Contact Administrator</strong>
                                                <span>Reach out to your KTPL Account Manager or Admin to upload your signed agreement.</span>
                                            </div>
                                        </div>
                                        <div className="tnc-step-item">
                                            <div className="tnc-step-num">2</div>
                                            <div className="tnc-step-content">
                                                <strong>Wait for Upload</strong>
                                                <span>Once the administrative team uploads the document, it will immediately reflect here.</span>
                                            </div>
                                        </div>
                                        <div className="tnc-step-item">
                                            <div className="tnc-step-num">3</div>
                                            <div className="tnc-step-content">
                                                <strong>Refresh & Verify</strong>
                                                <span>Click "Check Again" below to reload your profile and complete OTP verification.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Action Buttons inside Card */}
                                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 pt-3 border-top">
                                    <div className="d-flex align-items-center gap-2">
                                        <CButton
                                            color="primary"
                                            className="d-flex align-items-center gap-2 px-3 py-2 fw-medium shadow-sm"
                                            onClick={handleReload}
                                            disabled={isReloading}
                                        >
                                            <HiOutlineArrowPath className={`fs-5 ${isReloading ? "spinner-border spinner-border-sm" : ""}`} />
                                            <span>{isReloading ? "Checking..." : "Check Again / Refresh"}</span>
                                        </CButton>

                                        <CButton
                                            color="light"
                                            variant="ghost"
                                            className="d-flex align-items-center gap-2 px-3 py-2 text-danger border"
                                            onClick={handlelogOut}
                                        >
                                            <HiOutlineArrowRightOnRectangle className="fs-5" />
                                            <span>Log Out</span>
                                        </CButton>
                                    </div>

                                    <div className="d-flex align-items-center gap-2 text-muted small tnc-support-banner">
                                        <HiOutlineEnvelope className="fs-5 text-primary" />
                                        <span>Helpdesk: <strong className="text-dark">support@kurumatravels.com</strong></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </CModalBody>

                <CModalFooter className={`px-4 py-3 border-top ${hasDocument ? 'bg-white' : 'bg-light'}`}>
                    {
                        hasDocument ? (
                            <div className="d-flex w-100 justify-content-between align-items-center flex-wrap gap-2">
                                <div className="d-flex align-items-center">
                                    <CFormCheck
                                        label={hasDocument ? "I have read and agree to the Terms and Conditions" : "Accept terms and conditions"}
                                        id="tnc-agree-checkbox"
                                        checked={acceptTnC}
                                        onChange={() => setAcceptTnC(!acceptTnC)}
                                        className="fw-medium text-dark"
                                    />
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <CButton
                                        color="light"
                                        variant="ghost"
                                        onClick={handlelogOut}
                                        className="text-secondary"
                                    >
                                        Log Out
                                    </CButton>
                                    <CButton
                                        color="primary"
                                        onClick={() => handleVerify()}
                                        disabled={!acceptTnC}
                                        className="px-4 fw-medium shadow-sm"
                                    >
                                        Verify
                                    </CButton>
                                </div>
                            </div>
                        ) : (
                            <div className="d-flex w-100 justify-content-between align-items-center flex-wrap gap-2">
                                <div className="d-flex align-items-center">
                                    <CFormCheck
                                        label={hasDocument ? "I have read and agree to the Terms and Conditions" : "Accept terms and conditions"}
                                        disabled={!hasDocument}
                                        id="tnc-agree-checkbox"
                                        checked={acceptTnC}
                                        onChange={() => setAcceptTnC(!acceptTnC)}
                                        className="fw-medium text-dark"
                                    />
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <CButton
                                        color="light"
                                        variant="ghost"
                                        onClick={handlelogOut}
                                        className="text-secondary"
                                    >
                                        Log Out
                                    </CButton>
                                    <CButton
                                        color="primary"
                                        onClick={() => handleVerify()}
                                        disabled={!hasDocument}
                                        className="px-4 fw-medium shadow-sm"
                                    >
                                        Verify
                                    </CButton>
                                </div>
                            </div>
                        )
                    }
                </CModalFooter>
            </CModal>
        </div>
    );
};

export default TncModal;